import React, { forwardRef, useImperativeHandle, useContext, useRef } from "react";
import { Text } from "@fluentui/react";
import { SubledgerContext } from "../../contexts/SubledgerContext";
import MultiAutocomplete, { MultiAutocompleteRef } from "../../baseComponents/MultiAutocomplete";

interface ISLSearchCompanyCodesAutocompleteProps {
  loading: boolean;
}

export interface ISLSearchCompanyCodesAutocompleteRef {
  getCompanyCodes: () => string[];
  setInitialCompanyCodes: (initialCompanyCodes: string[]) => void;
  reset: () => void;
}

const SLSearchCompanyCodesAutocomplete = forwardRef((props: ISLSearchCompanyCodesAutocompleteProps, ref) => {
  const { companyCodes } = useContext(SubledgerContext);
  const autocompleteRef = useRef<MultiAutocompleteRef>(null);

  useImperativeHandle(ref, () => ({
    getCompanyCodes() {
      if (autocompleteRef.current) {
        return autocompleteRef.current.getSelectedItems();
      }
      return [];
    },
    setInitialCompanyCodes(theInitialCompanyCodes: string[]) {
      if (autocompleteRef.current) {
        autocompleteRef.current.setInitialSelectedItems(theInitialCompanyCodes);
      }
    },
    reset() {
      if (autocompleteRef.current) {
        autocompleteRef.current.reset();
      }
    }
  }));

  return (
    <React.Fragment>
      <MultiAutocomplete
        label="Company Code"
        required={false}
        items={companyCodes.value}
        ref={autocompleteRef}
        disabled={props.loading}
        transformSelection={(item) => {
          return (item as string).substring(0, 4);
        }}
      />
      <Text
        nowrap
        variant="xSmall"
        block
        style={{
          marginTop: "4px",
          color: "var(--accent-font-color, #727272)"
        }}
      >
        Multiple company codes enabled. Separate by semicolons.
      </Text>
    </React.Fragment>
  );
});

SLSearchCompanyCodesAutocomplete.displayName = "SLSearchCompanyCodesAutocomplete";

export default SLSearchCompanyCodesAutocomplete;
